import { Component, OnInit } from '@angular/core';
import { CopyWriteService} from './../services/copywrite.service';

@Component({
   // moduleId: module.id,
    selector: 'copywrite',
    template: require('./copywrite.component.html'),
   // templateUrl: 'alert.component.html'
})

export class CopyWriteComponent {
    message: any;

    constructor(private copywriteService: CopyWriteService) { }

    ngOnInit() {
        //alert(this.message);
        
        this.copywriteService.getMessage().subscribe(message => { this.message = message; });
    }
}


// WEBPACK FOOTER //
// ./resources/assets/typescript/_copywrite/copywrite.component.ts